// src/components/watchDetail/RaceTimer/RaceTimer.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./RaceTimer.css";

const RaceTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 0,
    seconds: 0,
  });

  const [elapsedTime, setElapsedTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        const totalSeconds = prev.hours * 3600 + prev.minutes * 60 + prev.seconds;
        if (totalSeconds <= 0) {
          clearInterval(timer);
          return { hours: 0, minutes: 0, seconds: 0 };
        }
        const newTotalSeconds = totalSeconds - 1;
        return {
          hours: Math.floor(newTotalSeconds / 3600),
          minutes: Math.floor((newTotalSeconds % 3600) / 60),
          seconds: newTotalSeconds % 60,
        };
      });

      setElapsedTime((prev) => {
        const totalSeconds = prev.hours * 3600 + prev.minutes * 60 + prev.seconds + 1;
        return {
          hours: Math.floor(totalSeconds / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatNumber = (number) => String(number).padStart(2, '0');

  return (
    <div className="">
      <div className="flex gap-10">
        <div className="text-lg font-bold flex-grow">Live Race</div>
        <div className="flex flex-col gap-3">
          <div className="timer-label">Time Remaining</div>
          <div className="horizontal-timer">
            <div className="time-unit">
              <span className="time-value">
                {formatNumber(timeLeft.hours)}
              </span>
              <span className="time-label">Hrs</span>
            </div>
            <div className="time-unit">
              <span className="time-value">
                {formatNumber(timeLeft.minutes)}
              </span>
              <span className="time-label">Mins</span>
            </div>
            <div className="time-unit">
              <span className="time-value">
                {formatNumber(timeLeft.seconds)}
              </span>
              <span className="time-label">Secs</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <div className="timer-label">Time Elapsed</div>
          <div className="horizontal-timer">
            <div className="time-unit">
              <span className="time-value">
                {formatNumber(elapsedTime.hours)}
              </span>
              <span className="time-label">Hrs</span>
            </div>
            <div className="time-unit">
              <span className="time-value">
                {formatNumber(elapsedTime.minutes)}
              </span>
              <span className="time-label">Mins</span>
            </div>
            <div className="time-unit">
              <span className="time-value">
                {formatNumber(elapsedTime.seconds)}
              </span>
              <span className="time-label">Secs</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

RaceTimer.propTypes = {
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
};

export default RaceTimer;
